import SkuQuantity from 'components/Product/SkuQuantity/SkuQuantity';
import { withSkuQuantityProps } from 'viewModel/product/skuQuantity/withSkuQuantityProps';

export default withSkuQuantityProps(SkuQuantity);
